import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { hebrewDayNameGenerator } from "../../utils/hebrewDayNameGenerator";
import { calculateEndTimeOfAppointment } from "../../utils/calculateEndTimeOfAppointment";
import { CalendarIcon1Svg } from "../../svgs/calendarIcon1Svg";
import { ClockIcon1Svg } from "../../svgs/clockIcon1Svg";
import { LocationIcon2Svg } from "../../svgs/locationIcon2Svg";
import { UserGroupIconSvg } from "../../svgs/userGroupIconSvg";
import { PadLockIconSvg } from "../../svgs/padLockIconSvg";
import { paths } from "../../routes/paths";
import styles from "../../styles/_containers/_class/classHeader.module.scss";

const ClassHeader = ({ appointment, participantCount, onCancelClass }) => {
  const navigate = useNavigate();

  if (!appointment) return null;

  const service = appointment.serviceId;
  const date = new Date(appointment.date);
  const dayName = hebrewDayNameGenerator(
    format(date, "EEEE").toLowerCase()
  );
  const dateStr = format(date, "dd/MM/yyyy");
  const endTime = calculateEndTimeOfAppointment(
    appointment.timeSlot,
    service.time
  );

  const max = service.maximumQueue || 0;
  const count = participantCount;
  const ratio = max > 0 ? count / max : 0;
  const capacityClass =
    ratio >= 1 ? styles.chipRed : ratio >= 0.8 ? styles.chipAmber : styles.chipGreen;

  return (
    <div className={styles.container}>
      <div
        className={styles.backLink}
        onClick={() => navigate(paths.appointments)}
      >
        <img src="/assets/chevron-down.svg" alt="back" />
        <span>חזרה ליומן</span>
      </div>

      <h1 className={styles.serviceName}>{service.name}</h1>

      <div className={styles.metaRow}>
        <span>
          <CalendarIcon1Svg fill="#6b7280" />
          {dayName}, {dateStr}
        </span>
        <span className={styles.separator}>·</span>
        <span>
          <ClockIcon1Svg fill="#6b7280" />
          {appointment.timeSlot}-{endTime}
        </span>
        {service.location && (
          <>
            <span className={styles.separator}>·</span>
            <span>
              <LocationIcon2Svg fill="#6b7280" />
              {service.location}
            </span>
          </>
        )}
      </div>

      <div className={styles.chips}>
        <div className={capacityClass}>
          <UserGroupIconSvg fill="currentColor" />
          {count}/{max} משתתפים
        </div>
        <div className={styles.chip}>
          <PadLockIconSvg fill="#374151" />
          {service.forSubscriptionOnly ? "למנויים בלבד" : "פתוח לכולם"}
        </div>
        <button className={styles.cancelBtn} onClick={onCancelClass}>
          ביטול שיעור
        </button>
      </div>
    </div>
  );
};

export default ClassHeader;
